import createIconComponent from './utils/createIconComponent';
import React from 'react';
const InCorrectSquareSolid = createIconComponent({
  height: 30,
  width: 30,
  content: (
    <g>
      <rect height='34.24886' width='34.37386' />
      <rect
        fill='#efefef'
        transform='rotate(-45 15.000000000000002,15.000000000000002) '
        height='3'
        width='15'
        y='13.5'
        x='7.5'
      />
      <rect
        fill='#efefef'
        transform='rotate(-135 15,15) '
        rx='1.5'
        height='3'
        width='15'
        y='13.5'
        x='7.5'
      />
    </g>
  ),
});
InCorrectSquareSolid.displayName = 'InCorrectSquareSolid';
export default InCorrectSquareSolid;
